import React from 'react';
import CameraCapture from '../CameraCapture';

const CATEGORIES = [
  '', 'Hauptgerichte', 'Suppen & Eintöpfe', 'Salate', 'Pasta & Nudeln',
  'Reis & Getreide', 'Desserts & Süßes', 'Frühstück & Brunch',
  'Gemüse & Beilagen', 'Hülsenfrüchte', 'Pizza & Flammkuchen',
  'Aufläufe & Gratins', 'Snacks & Fingerfood', 'Fisch & Meeresfrüchte',
  'Fleisch & Geflügel', 'Geflügel', 'Vegetarisch', 'Vegan',
  'Festliche Gerichte', 'Grill & BBQ', 'Aus dem Ofen', 'Getränke',
];

export default function RecipeMeta({
  formData,
  handleChange,
  tagInput,
  setTagInput,
  addTag,
  removeTag,
  recipeId,
  showDeleteConfirm,
  setShowDeleteConfirm,
  navigate,
  user,
  imagePreview,
  imageInputRef,
  handleImageChange,
  handleImageRemove,
  handleCoverCameraCapture,
  showCoverCamera,
  setShowCoverCamera,
  hasCamera,
  footer,
}) {
  return (
    <div className="editor-sidebar-panel">

      {/* Autor */}
      {user && (
        <div className="sidebar-panel">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div className="sb-user-av" style={{ width: 36, height: 36, fontSize: '0.85rem', flexShrink: 0 }}>
              {(user.username || '?')[0].toUpperCase()}
            </div>
            <div>
              <div style={{ fontSize: '0.83rem', fontWeight: 700, color: 'var(--txt)' }}>{user.username}</div>
              <div style={{ fontSize: '0.7rem', color: 'var(--txt3)' }}>Entwurf · nicht gespeichert</div>
            </div>
          </div>
        </div>
      )}

      {/* Sichtbarkeit */}
      <div className="sidebar-panel">
        <div className="sidebar-panel-title">Sichtbarkeit</div>
        <div className="vis-toggle">
          <button
            type="button"
            className={`vis-btn${!formData.is_public ? ' active' : ''}`}
            onClick={() => handleChange('is_public', false)}
          >Privat</button>
          <button
            type="button"
            className={`vis-btn${formData.is_public ? ' active' : ''}`}
            onClick={() => handleChange('is_public', true)}
          >Öffentlich</button>
        </div>
        <div className="vis-hint">
          {formData.is_public ? 'Alle angemeldeten Nutzer können es sehen.' : 'Nur du siehst dieses Rezept.'}
        </div>
      </div>

      {/* Kategorie */}
      <div className="sidebar-panel">
        <div className="sidebar-panel-title">Kategorie</div>
        <select
          className="field-select"
          value={formData.category}
          onChange={e => handleChange('category', e.target.value)}
        >
          {CATEGORIES.map(c => <option key={c} value={c}>{c || '– Bitte wählen –'}</option>)}
        </select>
      </div>

      {/* Titelbild */}
      <div className="sidebar-panel">
        <div className="sidebar-panel-title">Titelbild</div>
        <div className="upload-notice-warn">
          Bitte nur Bilder hochladen, an denen du die Rechte besitzt.
        </div>
        {imagePreview ? (
          <div className="upload-thumb" style={{ position: 'relative', cursor: 'default' }}>
            <img src={imagePreview} alt="Vorschau" />
            <button
              type="button"
              onClick={e => { e.stopPropagation(); handleImageRemove(); }}
              title="Bild entfernen"
              style={{
                position: 'absolute', top: 6, right: 6,
                background: 'rgba(0,0,0,0.55)', color: 'var(--surface)',
                border: 'none', borderRadius: '50%',
                width: 24, height: 24, fontSize: '1rem',
                cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                lineHeight: 1, zIndex: 2,
              }}
            >×</button>
          </div>
        ) : (
          <div className="upload-thumb" onClick={() => imageInputRef?.current?.click()}>
            <svg viewBox="0 0 24 24">
              <rect x="3" y="3" width="18" height="18" rx="2"/>
              <circle cx="8.5" cy="8.5" r="1.5"/>
              <polyline points="21 15 16 10 5 21"/>
            </svg>
            <span className="upload-thumb-label">Bild auswählen</span>
            <span className="upload-thumb-hint">JPG, PNG · max. 10 MB</span>
          </div>
        )}
        <input
          ref={imageInputRef}
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={handleImageChange}
        />
        {hasCamera && (
          <button type="button" className="upload-camera-btn" onClick={() => setShowCoverCamera(true)}>
            📸 Kamera öffnen
          </button>
        )}
        {showCoverCamera && (
          <CameraCapture
            onCapture={file => { handleCoverCameraCapture(file); setShowCoverCamera(false); }}
            onClose={() => setShowCoverCamera(false)}
          />
        )}
      </div>

      {/* Tags */}
      <div className="sidebar-panel">
        <div className="sidebar-panel-title">Tags</div>
        <div className="tags-input" onClick={e => e.currentTarget.querySelector('input')?.focus()}>
          {formData.tags.map(tag => (
            <span key={tag} className="tag-item">
              {tag}
              <button type="button" className="tag-remove" onClick={() => removeTag(tag)}>×</button>
            </span>
          ))}
          <input
            type="text"
            className="tags-field-input"
            placeholder="Tag eingeben …"
            value={tagInput}
            onChange={e => setTagInput(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addTag(tagInput); } }}
          />
        </div>
        <div className="tags-hint">Enter drücken um Tag hinzuzufügen</div>
      </div>

      {/* Gefahren-Zone */}
      {recipeId && (
        <div className="sidebar-panel-danger">
          <div className="sidebar-panel-title">Gefahren-Zone</div>
          {showDeleteConfirm ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <span style={{ fontSize: '0.83rem', color: 'var(--txt)' }}>Rezept wirklich löschen?</span>
              <button type="button" className="btn btn-danger" onClick={() => navigate('/')}>Ja, löschen</button>
              <button type="button" className="btn btn-ghost" onClick={() => setShowDeleteConfirm(false)}>Abbrechen</button>
            </div>
          ) : (
            <button type="button" className="btn btn-danger" onClick={() => setShowDeleteConfirm(true)}>
              Rezept löschen
            </button>
          )}
        </div>
      )}

      {footer}

    </div>
  );
}
